import { DateRangeInterface } from '../models/date-range/date-range.interface';
import { PlainRangeInterface } from '../models/range.interface';
import { TsRangeInterface } from '../models/ts-range/ts-range.interface';

export function isRange<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
>(
  value: TsRangeInterface<StartBoundary, EndBoundary>,
): value is TsRangeInterface<StartBoundary, EndBoundary>;
export function isRange<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
>(
  value: DateRangeInterface<StartBoundary, EndBoundary>,
): value is DateRangeInterface<StartBoundary, EndBoundary>;
export function isRange<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
>(
  value: PlainRangeInterface<StartBoundary, EndBoundary>,
): value is PlainRangeInterface<StartBoundary, EndBoundary>;
export function isRange<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(value: {
  start: PlainStartType;
  end: PlainEndType;
  inclusiveEnd: boolean;
  inclusiveStart: boolean;
}): value is
  | PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>
  | DateRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>
  | TsRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>;
export function isRange<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(value: {
  start: PlainStartType;
  end: PlainEndType;
  inclusiveEnd: boolean;
  inclusiveStart: boolean;
}): value is
  | PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>
  | DateRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>
  | TsRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>;
export function isRange(
  value: unknown,
): value is
  | PlainRangeInterface<'finite' | 'infinite', 'finite' | 'infinite'>
  | DateRangeInterface<'finite' | 'infinite', 'finite' | 'infinite'>
  | TsRangeInterface<'finite' | 'infinite', 'finite' | 'infinite'>;
export function isRange(
  value: unknown,
): value is PlainRangeInterface | DateRangeInterface | TsRangeInterface {
  return !!(
    value &&
    typeof value === 'object' &&
    'start' in value &&
    'end' in value &&
    'inclusiveEnd' in value &&
    'inclusiveStart' in value
  );
}
